import { useTranslation } from "react-i18next";

// Textos que a interface grava no histórico em nome do usuário, nos dois idiomas
// (uma conversa pode ter começado em outro idioma).
export const useTextosInterface = () => {
  const { i18n } = useTranslation();
  const chaves = ["preciso_mais_ajuda", "fb_msg_nao_entendi"];

  return ["pt", "es"].flatMap((lng) =>
    chaves.map((chave) => i18n.getFixedT(lng)(chave))
  );
};
